// extracted by mini-css-extract-plugin
export default {"Discount":"mvef7KLVuA0kH4DqkI9d","Discount__row":"uuYXpKDTmhcKG2SjL9dg","Discount__discount-code":"bH_pMtMbzBAcsvlDkQ5A","Discount__delete-button":"SLXsF0PCCnXGrwEj2S_A"};